import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, vModelCheckbox as _vModelCheckbox, mergeProps as _mergeProps, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = ["data-test", "data-testid"]
const _hoisted_2 = ["id", "name", "disabled", "required"]
const _hoisted_3 = ["aria-checked", "aria-required", "aria-disabled", "aria-invalid", "aria-labelledby"]
const _hoisted_4 = ["data-test"]
const _hoisted_5 = ["id", "innerHTML"]
const _hoisted_6 = ["innerHTML"]

import { computed, useAttrs } from "vue";
import DsIcon from "../../icon/ds-icon.vue";
import { Theme } from "../../types/theme";


export default /*@__PURE__*/_defineComponent({
  ...{ inheritAttrs: false },
  __name: 'ds-checkbox',
  props: /*@__PURE__*/_mergeModels({
    id: {},
    label: {},
    supportingText: {},
    errorMessage: {},
    disabled: { type: Boolean },
    required: { type: Boolean },
    theme: {},
    dataTestLabel: {},
    dataTestTexts: {},
    isInStorybook: { type: Boolean },
    dataTestid: {}
  }, {
    "modelValue": { type: Boolean },
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props: any) {

const props = __props;


const { class: wrapperClass, ...attrs } = useAttrs();

/**
 * The v-model for the checkbox.
 */
const modelValue = _useModel<boolean>(__props, "modelValue");

/**
 * The error messages for the checkbox. If array isn't empty, the checkbox is invalid and it will display the error message instead of the supporting text.
 */

const isValid = computed(() => !props.errorMessage);

const checkboxKeydownEventHandler = (event: KeyboardEvent) => {
    if (!props.disabled && (event.key === "Enter" || event.key === "Space")) {
        modelValue.value = !modelValue.value;
    }
};

const ariaLabelId = computed(() => `label-${props.id.replace(/\s+/g, "-").toLowerCase()}`);

const rootClasses = computed(() => {
    return [
        props.theme === "dark" ? "theme--dark" : "",
        props.disabled ? "disabled" : "",
        !isValid.value ? "has-error" : "",
        modelValue.value ? "checked" : "",
    ];
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("label", {
    class: _normalizeClass(["ds-checkbox", [_unref(wrapperClass), rootClasses.value]]),
    "data-test": _ctx.dataTestLabel,
    "data-testid": _ctx.dataTestid
  }, [
    _withDirectives(_createElementVNode("input", _mergeProps({
      type: "checkbox",
      class: "ds-checkbox__input",
      id: _ctx.id,
      name: _ctx.id,
      disabled: _ctx.disabled,
      required: _ctx.required,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((modelValue).value = $event))
    }, attrs), null, 16, _hoisted_2), [
      [_vModelCheckbox, modelValue.value]
    ]),
    _createElementVNode("div", {
      class: "ds-checkbox__checkbox",
      tabindex: "0",
      onKeydown: checkboxKeydownEventHandler,
      role: "checkbox",
      "aria-checked": modelValue.value,
      "aria-required": _ctx.required,
      "aria-disabled": _ctx.disabled,
      "aria-invalid": !isValid.value,
      "aria-labelledby": ariaLabelId.value
    }, [
      _createVNode(DsIcon, {
        width: 16,
        height: 16,
        name: "check",
        class: "ds-checkbox__checkmark",
        "is-in-storybook": _ctx.isInStorybook
      }, null, 8, ["is-in-storybook"])
    ], 40, _hoisted_3),
    _createElementVNode("div", {
      class: "ds-checkbox__texts",
      "data-test": _ctx.dataTestTexts
    }, [
      _createElementVNode("span", {
        class: "ds-checkbox__label",
        id: ariaLabelId.value,
        innerHTML: _ctx.label
      }, null, 8, _hoisted_5),
      (_ctx.errorMessage || _ctx.supportingText)
        ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            class: _normalizeClass(["ds-checkbox__message", { 'ds-checkbox__message--floating': !_ctx.supportingText }]),
            innerHTML: _ctx.errorMessage || _ctx.supportingText,
            role: "alert",
            "aria-live": "polite",
            "aria-atomic": "true"
          }, null, 10, _hoisted_6))
        : _createCommentVNode("", true)
    ], 8, _hoisted_4),
    _renderSlot(_ctx.$slots, "default")
  ], 10, _hoisted_1))
}
}

})